<footer class="wr-pricing-footer" style="background-color: #3b3355">

    <div class="wr-pricing-footer__left">
      <img src="https://premium.gotyourbacksupport.com/wp-content/uploads/2022/04/footer_image.png" alt=""
           class="wr-pricing-footer__image">
      <div class="wr-pricing-footer__left__info">
        <a href="https://premium.gotyourbacksupport.com/" class="wr-pricing-footer__logo">
          <img src="https://premium.gotyourbacksupport.com/wp-content/uploads/2022/04/footer_logo.svg" alt="">
        </a>
        <div class="wr-pricing-footer__left__links">
          <div class="wr-pricing-footer__left__links--item">
            <div class="wr-pricing-footer__left__links--title">
              Menu
            </div>
            <div class="wr-pricing-footer__left__links__list">
              <div class="wr-pricing-footer__left__links__list--item">
                <a href="https://premium.gotyourbacksupport.com/">
                  Home </a>
              </div>
              <div class="wr-pricing-footer__left__links__list--item">
                <a href="https://premium.gotyourbacksupport.com/service/">
                  Services </a>
              </div>
              <div class="wr-pricing-footer__left__links__list--item">
                <a href="https://premium.gotyourbacksupport.com/contacts/">
                  Contacts </a>
              </div>
            </div>
          </div>
          <div class="wr-pricing-footer__left__links--item">
            <div class="wr-pricing-footer__left__links--title">
              Resources
            </div>
            <div class="wr-pricing-footer__left__links__list">
              <div class="wr-pricing-footer__left__links__list--item">
                <a href="https://premium.gotyourbacksupport.com/privacy-policy/">
                  Privacy Policy </a>
              </div>
              <div class="wr-pricing-footer__left__links__list--item">
                <a href="https://premium.gotyourbacksupport.com/cookie-policy/">
                  Cookie Policy </a>
              </div>
              <div class="wr-pricing-footer__left__links__list--item">
                <a href="https://premium.gotyourbacksupport.com/terms/">
                  Terms of Use </a>
              </div>
              <div class="wr-pricing-footer__left__links__list--item">
                <a href="https://premium.gotyourbacksupport.com/gdpr-notice/">
                  GDPR Notice </a>
              </div>
              <div class="wr-pricing-footer__left__links__list--item">
                <a href="https://premium.gotyourbacksupport.com/refund-policy/">
                  Refund Policy </a>
              </div>
              <div class="wr-pricing-footer__left__links__list--item">
                <a href="https://premium.gotyourbacksupport.com/ccpa-notice/">
                  CCPA Notice </a>
              </div>
              <div class="wr-pricing-footer__left__links__list--item">
                <a href="https://premium.gotyourbacksupport.com/eula/">
                  EULA </a>
              </div>
            </div>
          </div>
        </div>
        <div class="wr-pricing-footer__right wr-pricing-footer__right--mobile" style="background-color: #e0f466">
          <div class="wr-pricing-footer__right--list">
            <div class="wr-pricing-footer__right--list--item">
              <div class="wr-pricing-footer__right--item--title">
                Contacts
              </div>
              <div class="wr-pricing-footer__right--add">
                <div class="wr-pricing-footer__right--item">
                  <a href="tel:+1 800 650 3190" class="wr-pricing-footer__right--add--item">
                    +1 800 650 3190 </a>
                </div>
                <div class="wr-pricing-footer__right--item">
                  <a href="tel:+44 800 920 2490" class="wr-pricing-footer__right--add--item">
                    +44 800 920 2490 </a>
                </div>
                <div class="wr-pricing-footer__right--item">
                  <a href="tel:+61 1800 370 680 " class="wr-pricing-footer__right--add--item">
                    +61 1800 370 680 </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wr-pricing-footer__right--copyright wr-pricing-footer__right--copyright--mobile">
          <p>© 2023 GotYoutBack Inc.</p>
        </div>
      </div>
    </div>
  
    <div class="wr-pricing-footer__right" style="background-color: #e0f466">
      <div class="wr-pricing-footer__right--list">
        <div class="wr-pricing-footer__right--list--item">
          <div class="wr-pricing-footer__right--item--title">
            Contacts
          </div>
          <div class="wr-pricing-footer__right--add">
            <div class="wr-pricing-footer__right--item">
              <span>US</span>
              <a href="tel:+1 800 650 3190" class="wr-pricing-footer__right--add--item">
                +1 800 650 3190 </a>
            </div>
            <div class="wr-pricing-footer__right--item">
              <span>UK</span>
              <a href="tel:+44 800 920 2490" class="wr-pricing-footer__right--add--item">
                +44 800 920 2490 </a>
            </div>
            <div class="wr-pricing-footer__right--item">
              <span>AU</span>
              <a href="tel:+61 1800 370 680 " class="wr-pricing-footer__right--add--item">
                +61 1800 370 680 </a>
            </div>
          </div>
        </div>
      </div>
      <div class="wr-pricing-footer__right--copyright">
        <p>© 2023 GotYoutBack Inc.</p>
      </div>
    </div>
  
</footer>
  